<template>
  <div>
    <div
      v-for="activity in visible"
      :key="activity.id"
      class="md:flex text-sm group"
      :class="subtle ? 'mb-4' : 'mb-2'"
    >
      <div class="text-gray-500" :class="subtle ? 'w-24' : 'py-1 md:py-3 w-32'">
        <div class="flex items-center">
          <BaseIcon :name="activity.icon" size="16" class="mr-2" v-if="!subtle" />
          <div class="text-gray-800">
            {{ activity.created_at | formatDay('D MMM.') }}
            <div
              class="hidden md:block text-xs absolute group-hover:visible invisible text-gray-500"
            >{{ activity.done_by.name_short }}</div>
          </div>
        </div>
      </div>
      <component v-bind:is="activity.component" :activity="activity" :subtle="subtle" />
    </div>
  </div>
</template>

<script>
import Activity from "./activities/Activity";
import NoteCreated from "./activities/NoteCreated";

const COMPONENT_MAP = {
  note_created: "NoteCreated",
  reminder_done: "NoteCreated"
};

const ICON_MAP = {
  note_created: "file-text",
  reminder_created: "clock",
  reminder_done: "check",
  deal_created: "briefcase",
  deal_lost: "briefcase",
  deal_won: "briefcase"
};

export default {
  props: {
    showAll: {
      type: Boolean
    },
    activities: {
      type: Array,
      default: () => []
    },
    subtle: Boolean
  },

  components: {
    Activity,
    NoteCreated
  },

  data() {
    return {
      show: false
    };
  },

  computed: {
    visible() {
      return this.activities
        .filter(activity => this.showAll || activity.is_visible)
        .map(activity => {
          let component = COMPONENT_MAP[activity.type] || "Activity";
          let icon = ICON_MAP[activity.type] || "info";
          return { ...activity, component, icon };
        });
    }
  }
};
</script>
